const recaptchaProdKey = '6LeGxnYrAAAAAPzs-oPWnAMAdJ3pnH9bTi_ff12F'
const recaptchaDevKey = '6LfA5X0rAAAAAKPSxqYJbpZItSQxyXZZEFndYi2j'

const dev = {
  SERVER: '',
  MAP_SERVER: '',
  GM_API_KEY: 'AIzaSyClLpOFxDkYZypbH2P6avw4AazGk_RhUOs',
  FORM_SERVER: 'http://localhost:3001',
  PAGE_FOOTER: 11023,
  RECAPTCHA_KEY: recaptchaDevKey,
  WEATHER_SERVER: 'https://alpha.hylyt.net',
  AIAPI_URL: 'http://localhost:3001',
}

const prod = {
  SERVER: 'https://cms.hylyt.net',
  MAP_SERVER: 'https://hylyt.net',
  GM_API_KEY: 'AIzaSyClLpOFxDkYZypbH2P6avw4AazGk_RhUOs',
  FORM_SERVER: '',
  PAGE_FOOTER: 11023,
  RECAPTCHA_KEY: recaptchaProdKey,
  WEATHER_SERVER: '',
  AIAPI_URL: 'https://aiapi.hylyt.net',
}

//tässä tallessa mapsin tuotantotunnarit tod näk
const mapprod = {
  SERVER: 'https://cms.hylyt.net',
  MAP_SERVER: 'https://hylyt.net',
  GM_API_KEY: 'AIzaSyCl2g7Srrvcbpe5TiXyLBPDAQfNcfIZnsY',
  FORM_SERVER: '',
  PAGE_FOOTER: 11023,
  RECAPTCHA_KEY: recaptchaProdKey,
  WEATHER_SERVER: '',
  AIAPI_URL: 'https://aiapi.hylyt.net',
}

const test = {
  SERVER: 'https://beta.hylyt.net',
  MAP_SERVER: 'https://beta.hylyt.net',
  GM_API_KEY: 'AIzaSyClLpOFxDkYZypbH2P6avw4AazGk_RhUOs',
  FORM_SERVER: '',
  PAGE_FOOTER: 11023,
  RECAPTCHA_KEY: recaptchaDevKey,
  WEATHER_SERVER: '',
  AIAPI_URL: 'https://aiapibeta.hylyt.net',
}

const cmsbeta = {
  SERVER: 'https://cmsbeta.hylyt.net',
  MAP_SERVER: 'https://beta.hylyt.net',
  GM_API_KEY: 'AIzaSyClLpOFxDkYZypbH2P6avw4AazGk_RhUOs',
  FORM_SERVER: '',
  PAGE_FOOTER: 11023,
  RECAPTCHA_KEY: recaptchaDevKey,
  WEATHER_SERVER: '',
  AIAPI_URL: 'https://aiapibeta.hylyt.net',
}
const cmsalpha = {
  SERVER: 'https://cmsalpha.hylyt.net',
  MAP_SERVER: 'https://alpha.hylyt.net',
  GM_API_KEY: 'AIzaSyClLpOFxDkYZypbH2P6avw4AazGk_RhUOs',
  FORM_SERVER: '',
  PAGE_FOOTER: 11023,
  RECAPTCHA_KEY: recaptchaDevKey,
  WEATHER_SERVER: '',
  AIAPI_URL: 'https://aiapialpha.hylyt.net',
}

const config =
  process.env.REACT_APP_STAGE === 'prod'
    ? prod
    : process.env.REACT_APP_STAGE === 'dev'
      ? dev
      : process.env.REACT_APP_STAGE === 'test'
        ? test
        : process.env.REACT_APP_STAGE === 'mapprod'
          ? mapprod
          : process.env.REACT_APP_STAGE === 'cmsbeta'
            ? cmsbeta
            : process.env.REACT_APP_STAGE === 'cmsalpha'
              ? cmsalpha
              : prod

export default {
  ...config,
}
